/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment'
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { FilteredSearch, Scrollbars } from '../../../generic/'
import { useDimensions } from '../../../hooks'
import { getSystemAuditLogs } from '../../services/systemAudit'
import { SystemAuditCardList } from './components/SystemAuditCardList/SystemAuditCardList'
import { SystemAuditPagination } from './components/SystemAuditPagination/SystemAuditPagination'
import { SystemAuditHeaderViewContainer, SystemAuditViewContainer, SystemAuditViewWrapper } from './styles'

interface ISelectPagination {
    value: number
    label: string
}

interface IProps {
    systemAuditData: ISystemAudit[]
    setSystemAuditData: (k: ISystemAudit[]) => void
    isLoading: boolean
    setIsLoading: (k: boolean) => void
    total: number
    setTotal: (k: number) => void
    page: number
    setPage: (k: number) => void
    limit: ISelectPagination
    setLimit: (k: ISelectPagination) => void
    startDay?: string | null
    endDay?: string | null
    startHour?: string | null
    endHour?: string | null
    filterAuthor: ISelect
    filterStatus: ISelect
    filterHttpVerb: ISelect
    searchString: string
    setSearchString: (k: string) => void
}

export const SystemAuditView: React.FC<IProps> = ({
    startDay,
    endDay,
    startHour,
    endHour,
    systemAuditData,
    setSystemAuditData,
    isLoading,
    setIsLoading,
    limit,
    setLimit,
    page,
    setPage,
    total,
    setTotal,
    filterAuthor,
    filterStatus,
    filterHttpVerb,
    searchString,
    setSearchString
}) => {
    const dimensions = useDimensions({ height: 75 })

    const [offset, setOffset] = useState<number>(0)

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const handleGetFilteredSystemAuditData = async (): Promise<void> => {
        if (systemAuditData) {
            try {
                setIsLoading(true)

                const data = await getSystemAuditLogs({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,
                    page: page,
                    perPage: limit.value,
                    quickSearch: searchString,
                    filterByStatusCodeStatus: filterStatus.value,
                    filterByHTTPVerb: filterHttpVerb.value,
                    filterByLiveAuthor: filterAuthor.value
                })
                setSystemAuditData(data.data)
                setTotal(data.total)
            } catch (error) {
                globalNotification.error(i18n('An error occurred on listing audit logs'))
                console.log(error)
            } finally {
                setIsLoading(false)
            }
        }
    }

    console.log(isLoading)

    React.useEffect(() => {
        handleGetFilteredSystemAuditData()
    }, [searchString, page, limit.value])

    return (
        <SystemAuditViewWrapper>
            <SystemAuditViewContainer>
                <SystemAuditHeaderViewContainer>
                    <FilteredSearch
                        onSearch={value => setSearchString(value)}
                        inputId="systemAudit-systemAuditView-search-input"
                    />
                    <SystemAuditPagination
                        limit={limit}
                        setLimit={setLimit}
                        offset={offset}
                        setOffset={setOffset}
                        total={total}
                        setPage={setPage}
                    />
                </SystemAuditHeaderViewContainer>
                <SystemAuditCardList
                    loading={isLoading}
                    systemAuditData={systemAuditData}
                    height={dimensions.height - 32 - 100 - 16}
                />
            </SystemAuditViewContainer>
        </SystemAuditViewWrapper>
    )
}
